import { Outlet } from 'react-router';
import FrontendLayout from '@/components/layout/FrontendLayout';

export function OpsLayoutRoute() {
    return (
        <FrontendLayout frontend="ops">
            <Outlet />
        </FrontendLayout>
    );
}
